import { render, staticRenderFns } from "./VLoadSuccess.vue?vue&type=template&id=9f50c228&"
import script from "./VLoadSuccess.vue?vue&type=script&lang=js&"
export * from "./VLoadSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports